export class BankTransferRegister {
	date: string;
	reference: any;
	debit: number;
	credit: number;
	balance: number;
	description: string;
	operation: number;
	client: string;
}